import type { ApiRoute, NoPathParams, NoQueryParams } from "../api"
import type { CustomerType, CreateOfferResult } from "../common"

export interface CreateOfferBody {
	salesChannel: CustomerType
	vehicleId: string
}

export const createDosOfferRoute: ApiRoute<NoPathParams, NoQueryParams, CreateOfferBody, CreateOfferResult> = {
	buildUrl: () => "/dos-offers",
	method: "post",
	path: "/dos-offers",
}
